import { Button, Card, Col, Flex, Image, InputNumber, Modal, Row, Slider, Steps } from "antd";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { generateRandomString } from "utils/helper";
import iconBank from "../../../assets/images/bank.svg";
import iconTel from "../../../assets/images/tel.svg";
import { getCreditRemainder, getVerifyLoanRequest } from "../services/webAppApi";
import { setCreditRemainder, setIsLoading } from "../slices/webappSlice";
import styles from "../styles/TransactionStyles.module.css";

const useTransaction = () => {
    const dispatch = useDispatch()
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const { isLoading, creditRemainder } = useSelector((state) => state.webapp);
    const navigate = useNavigate();
    const [current, setCurrent] = useState(0);
    const [inputValue, setInputValue] = useState(1000);

    console.log("creditRemainder", creditRemainder);

    const onChange = (newValue) => {
        const roundedValue = Math.min(Math.round(newValue / 100) * 100, creditRemainder?.creditRemainder ?? 0);
        setInputValue(roundedValue);
    };


    const feeUse = useMemo(() => creditRemainder?.fee?.find(o => o.feeType == 'FEE_02') ?? {
        "feeType": "FEE_02",
        "feeUnit": "BATH",
        "feeAmount": 0
    }, [creditRemainder?.fee?.find(o => o.feeType == 'FEE_02')])

    const feeNet = useMemo(() => {
        if (feeUse?.feeUnit == 'BATH') {
            return (feeUse.feeAmount ?? 0)
        } else {
            return inputValue * (feeUse.feeAmount ?? 0) / 100
        }
    },
        [inputValue, feeUse])

    const serviceCreditRemainder = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getCreditRemainder({
                ...params,
                requestId: generateRandomString(),
                productCode: "BE0001"
            });
            // console.log("response", response);
            console.log("data", response.data);
            dispatch(setCreditRemainder(response.data))
        } catch (error) {
            console.log("error", error);
            dispatch(setCreditRemainder({}))
            // alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    const serviceVerifyLoanRequest = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getVerifyLoanRequest({
                ...params,
                requestId: generateRandomString(),
                creditUsage: inputValue,
                productCode: "BE0001"
            });
            console.log("response.data", response);

            return true
        } catch (error) {
            console.log("error", error);
            Modal.error({ content: error?.data?.status?.description })
            return false
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    useEffect(() => {
        serviceCreditRemainder()
    }, [])

    const next = async () => {
        console.log("current", current);
        if (current == 0) {
            let res = await serviceVerifyLoanRequest()
            if (res == true) {
                setCurrent(current + 1);
            }
        } else if (current == 1) {
            navigate("/webapp/consent", { state: { creditUsage: inputValue } })
        }
    };

    function cardFinanceAmount() {
        return (

            <Card style={{
                borderRadius: "1rem",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
                styles={{ body: { padding: isPortrait ? "2vh" : "2vw" } }}>
                <Flex vertical style={{ rowGap: "1vh" }}>
                    <Row>
                        <Col span={16}>
                            <span style={{ fontSize: isPortrait ? "2vh" : "2vw", fontWeight: "bold" }}>
                                วงเงินเบิกล่วงหน้าสูงสุดของคุณ
                            </span>
                        </Col>
                        <Col span={8} style={{ textAlign: "right" }}>
                            <span style={{ fontSize: isPortrait ? "2vh" : "2vw", fontWeight: "bold", color: "#FF9401" }}>
                                {get2DecimalPointsWithCommas(creditRemainder?.creditRemainder) + " บาท"}
                            </span>
                        </Col>
                    </Row>
                    <Flex vertical>
                        <span style={{ fontSize: isPortrait ? "2vh" : "2vw", fontWeight: "bold" }}>
                            วงเงินที่ต้องการขอ
                        </span>
                        <span style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw" }}>
                            เลื่อนสไลด์หรือพิมพ์จำนวนเงินเพื่อระบุวงเงินที่ต้องการ
                        </span>
                    </Flex>
                    <Row style={{ justifyContent: "center" }}>
                        <Col span={20}>
                            <Slider
                                className={styles.customSlider}
                                min={creditRemainder?.minimum ?? 0}
                                max={creditRemainder?.creditRemainder ?? 0}
                                step={100}
                                onChange={onChange}
                                value={typeof inputValue === 'number' ? inputValue : 0}
                                styles={{
                                    track: {
                                        backgroundColor: "#FF9401",
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    <Col span={20} style={{ alignSelf: "center" }}>
                        <span style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw" }}>
                            {`วงเงินขั้นต่ำ (${get2DecimalPointsWithCommas(creditRemainder?.minimum)} บาท)`}
                        </span>
                        <InputNumber
                            min={creditRemainder?.minimum ?? 0}
                            max={creditRemainder?.creditRemainder ?? 0}
                            style={{ width: '100%' }}
                            value={get2DecimalPointsWithCommas(inputValue)}
                            onChange={onChange}
                            addonAfter="บาท"
                        />
                    </Col>
                </Flex>
            </Card>
        )
    }

    function cardInfo() {
        return (
            <Card
                style={{ borderRadius: "1rem" }}
                styles={{ body: { padding: isPortrait ? "2vh" : "2vw" } }}
            >
                <Row>
                    <span style={{ fontSize: isPortrait ? "2vh" : "2vw", fontWeight: "bold" }}>รายละเอียด</span>
                </Row>
                <Row>
                    <Col span={16} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", }}>
                        <span>ยอดชำระต่อเดือน</span>
                    </Col>
                    <Col span={8} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(inputValue + feeNet) + " บาท"}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", }}>
                        <span>ยอดเบิกเงินล่วงหน้า</span>
                    </Col>
                    <Col span={8} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(inputValue) + " บาท"}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", }}>
                        <span>ค่าธรรมเนียม ({(feeUse?.feeAmount ?? 0)} {feeUse?.feeUnit == 'BATH' ? 'บาท' : '%'})</span>
                    </Col>
                    <Col span={8} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(feeNet) + " บาท"}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", }}>
                        <span>ดอกเบี้ย (0 % ต่อปี)</span>
                    </Col>
                    <Col span={8} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", textAlign: "right" }}>
                        <span>0.00 บาท</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", }}>
                        <span>ยอดรวมจ่ายคืน</span>
                    </Col>
                    <Col span={8} style={{ fontSize: isPortrait ? "1.8vh" : "1.8vw", textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(inputValue + feeNet) + " บาท"}</span>
                    </Col>
                </Row>
            </Card>
        )
    }

    function cardTransactionInfo() {
        return (
            <Card
                style={{ borderRadius: "1rem" }}
                styles={{ body: { padding: "2vh" } }}
            >
                <Row>
                    <span style={{ fontWeight: "bold" }}>ข้อมูลการทำรายการ</span>
                </Row>
                <Row>
                    <Col span={16}>
                        <span>ยอดชำระต่อเดือน</span>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(inputValue + feeNet) + " บาท"}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16}>
                        <span>ยอดเบิกเงินล่วงหน้า</span>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(inputValue) + " บาท"}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16}>
                        <span>ระยะเวลาผ่อนชำระ</span>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                        <span>1 เดือน</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16}>
                        <span>ค่าธรรมเนียม ({(feeUse?.feeAmount ?? 0)} {feeUse?.feeUnit == 'BATH' ? 'บาท' : '%'})</span>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(feeNet) + " บาท"}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16}>
                        <span>ดอกเบี้ย (0 % ต่อปี)</span>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                        <span>0.00 บาท</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={16}>
                        <span>ยอดรวมจ่ายคืน</span>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                        <span>{get2DecimalPointsWithCommas(inputValue + feeNet) + " บาท"}</span>
                    </Col>
                </Row>
            </Card>
        )
    }

    function cardContact() {
        return (
            <Card
                style={{ borderRadius: "1rem" }}
                styles={{ body: { padding: "2vh" } }}
            >
                <Flex vertical style={{ rowGap: "2vh" }}>
                    <Row>
                        <span style={{ fontWeight: "bold" }}>ช่องทางยืนยันการทำรายการ</span>
                    </Row>
                    <Card style={{ borderRadius: "1rem", backgroundColor: "#F8F8F8", width: "100%" }} styles={{ body: { padding: "2vh" } }}>
                        <Row>
                            <Col span={3}>
                                <Image src={iconTel} preview={false} width="3vh" />
                            </Col>
                            <Col span={10}>
                                <span style={{ color: "#909090" }}>หมายเลขโทรศัพท์</span>
                            </Col>
                            <Col span={11} style={{ textAlign: "right" }}>
                                <span style={{ color: "#909090" }}>{creditRemainder?.mobileNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}</span>
                            </Col>
                        </Row>
                    </Card>
                    <Row>
                        <span style={{ fontWeight: "bold" }}>ช่องทางรับเงิน</span>
                    </Row>
                    <Card style={{ borderRadius: "1rem", backgroundColor: "#F8F8F8", width: "100%" }} styles={{ body: { padding: "2vh" } }}>
                        <Row>
                            <Col span={3} style={{ alignContent: "center" }}>
                                <Image src={iconBank} preview={false} width="3vh" />
                            </Col>
                            <Col span={8} style={{ alignContent: "center" }}>
                                <span style={{ color: "#909090" }}>บัญชีธนาคาร</span>
                            </Col>
                            <Col span={13} style={{ textAlign: "right" }}>
                                <Flex vertical>
                                    <span style={{ color: "#909090", fontSize: isPortrait ? "1.8vh" : "1.8vw" }}>{creditRemainder?.bankName}</span>
                                    <span style={{ color: "#909090", fontSize: isPortrait ? "1.8vh" : "1.8vw" }}>{creditRemainder?.bankNameEn}</span>
                                    <span style={{ color: "#909090", fontSize: isPortrait ? "1.8vh" : "1.8vw" }}>{creditRemainder?.bankNumber?.replace(/(\d{7})(\d{4})/, "$1****")}</span>
                                </Flex>
                            </Col>
                        </Row>
                    </Card>
                </Flex>
            </Card>
        )
    }

    const steps = [
        {
            title: (
                <span style={{ fontSize: isPortrait ? "2vh" : "2vw" }}>
                    ข้อมูลการทำรายการ
                </span>
            ),
            content: (
                <Flex vertical style={{ rowGap: "3vh" }}>
                    {cardFinanceAmount()}
                    {cardInfo()}
                </Flex>
            ),
        },
        {
            title: (
                <span style={{ fontSize: isPortrait ? "2vh" : "2vw" }}>
                    ยืนยันการทำรายการ
                </span>
            ),
            content: (
                <Flex vertical style={{ rowGap: "3vh", overflow: "auto", height: "63vh", scrollbarWidth: "none" }}>
                    {cardTransactionInfo()}
                    {cardContact()}
                </Flex>
            ),
        },
    ];

    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));

    function stepTransaction() {
        return (
            <Flex vertical style={{ rowGap: "3vh" }}>
                <Steps current={current} items={items} style={{ width: "100%" }} className={styles.customStep}
                    labelPlacement="vertical" responsive={false}
                />
                <div>{steps[current].content}</div>
            </Flex>
        )
    }

    function transactionFooter() {
        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                backdropFilter: "blur(5px)",
                width: "100%",
                height: "11vh",
                position: "fixed",
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
                <Flex style={{ justifyContent: "center", width: "100%" }}>
                    <Button style={{
                        borderRadius: "4vh",
                        backgroundColor: "#FF9401",
                        borderColor: "#FF9401",
                        width: isPortrait ? "30vh" : "25vw",
                        height: isPortrait ? "5vh" : "7vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                        onClick={() => next()}>
                        <span style={{ color: "white", fontSize: isPortrait ? "2vh" : "1.9vw", }}>ต่อไป</span>
                    </Button>
                </Flex>
            </Card>
        )
    }

    return {
        stepTransaction,
        transactionFooter
    }
}
export default useTransaction;